const months = {
  1: "فروردین",
  2: "اردیبهشت",
  3: "خرداد",
  4: "تیر",
  5: "مرداد",
  6: "شهریور",
  7: "مهر",
  8: "آبان",
  9: "آذر",
  10: "دی",
  11: "بهمن",
  12: "اسفند",
};

const convertDateToString = (format = "number", fullDate) => {
  const seperateDate = fullDate.split(" ");
  const todayDate = seperateDate[0].split("-");
  if (format === "fullNumber") return seperateDate[0];
  if (format === "string") {
    return {
      year: Number(todayDate[0]),
      month: months[Number(todayDate[1])],
      day: Number(todayDate[2]),
    };
  }
  return {
    year: Number(todayDate[0]),
    month: Number(todayDate[1]),
    day: Number(todayDate[2]),
  };
};

export default convertDateToString;
